import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=3c450028&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "../assets/styles-new/confirm-order.sass?vue&type=style&index=0&id=3c450028&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c450028",
  null
  
)

export default component.exports